import { render, staticRenderFns } from "./ContainerFAQCategory.vue?vue&type=template&id=5458289c"
import script from "./ContainerFAQCategory.vue?vue&type=script&lang=js"
export * from "./ContainerFAQCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports